import React, { forwardRef, useCallback } from 'react';
import { useNavigationItemAnalyticsWithContext } from '@atlassian/jira-horizontal-nav-common/src/common/analytics.tsx';
import { V4 } from '@atlassian/jira-navigation-apps-sidebar-nav4-analytics/src/common/constants/analytics/nav-state.tsx';
import { TAB } from '@atlassian/jira-navigation-apps-sidebar-nav4-analytics/src/common/constants/analytics/navigation-container.tsx';
import { CONTAINER } from '@atlassian/jira-navigation-apps-sidebar-nav4-analytics/src/common/constants/analytics/navigation-layer.tsx';
import { getNav4Rollout } from '@atlassian/jira-navigation-apps-sidebar-nav4-rollout-core/src/common/utils/get-nav4-rollout/index.tsx';
import { TabList as PlatformTabList } from '@atlassian/navigation-kit-ui-tab-list';
import { OnboardingSpotlightMaybe } from '@atlassian/jira-atlassian-onboarding-nav4/src/ui/onboarding-spotlight-maybe/index.tsx';
import { Nav4OnboardingComponentNames } from '@atlassian/jira-atlassian-onboarding-nav4/src/types.tsx';

type Props = {
	addTab?: React.ReactNode;
	id?: string;
	label: string;
	selectedTabId?: string | null;
	tabs: { tab: React.ReactNode; id: string }[];
};

export const TabListWithAnalytics = forwardRef(
	({ addTab, id, label, selectedTabId, tabs }: Props, ref: React.Ref<HTMLDivElement>) => {
		const triggerAnalytics = useNavigationItemAnalyticsWithContext({
			itemType: 'more',
			navState: V4,
			stage: getNav4Rollout().stage,
			navigationLayer: CONTAINER,
			navigationContainer: TAB,
			isInMore: false,
		});
		const onMoreClick = useCallback(
			({ overflowingTabCount }: { overflowingTabCount: number }) => {
				triggerAnalytics({ childCount: overflowingTabCount });
			},
			[triggerAnalytics],
		);

		return (
			<OnboardingSpotlightMaybe spotlight={Nav4OnboardingComponentNames.TAB_NAV_SPOTLIGHT}>
				<PlatformTabList
					addTab={addTab}
					id={id}
					label={label}
					onMoreClick={onMoreClick}
					ref={ref}
					selectedTabId={selectedTabId}
					tabs={tabs}
				/>
			</OnboardingSpotlightMaybe>
		);
	},
);
